import React, { Component } from "react";
import { Empty, Layout, Row, Divider } from "antd";
import { Link } from "react-router-dom";
import GamatotoLogo from "../../img/gamatotologo.png";

const { Content } = Layout;

class EmptyPage extends Component {
  componentWillMount() {
    document.title = "Page does not exist | Battle Cats Wiki for Cat Stats";
  }

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              float: "left",
            }}
          >
            Nobody's Home
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content style={{ padding: "0 0px" }} className="flexible-width">
            <Row style={{ padding: "16px 0 16px 0" }}>
              <Empty
                description="Gamatoto reports that the page you have selected does not exist."
                image={GamatotoLogo}
                imageStyle={{ height: "40px" }}
              />
              <div style={{ textAlign: "center", marginTop: "48px" }}>
                <p>
                  Do you want to <Link to={"/comparecats"}>compare cats</Link>{" "}
                  or check out a full list of{" "}
                  <Link to={"/allcats"}>all cats</Link>?
                </p>
                <p>
                  Or do you want to{" "}
                  <Link to={"/allenemies"}>look up certain enemies</Link>?
                </p>
                <p>
                  Perhaps you'd like to{" "}
                  <Link to={"/allstages/search-by-stage-name"}>
                    search stages
                  </Link>{" "}
                  or{" "}
                  <Link to={"/allstages/search-by-stage-enemies"}>
                    fulfill monthly missions
                  </Link>
                  ?
                </p>
                <p>
                  If you're not sure, then Gamatoto recommends checking out the
                  lists, starting with the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  or the{" "}
                  <Link to={"/ultra-souls-tier-list"}>
                    Ultra Souls Tier List
                  </Link>
                  !
                </p>
              </div>
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default EmptyPage;



// WEBPACK FOOTER //
// ./src/components-kr/content/EmptyPage.js